import { MeshBVH, acceleratedRaycast } from "./three-mesh-bvh";
export class ThreeMeshBVHHelper {
  static assignBVH(mesh, bvh) {
    mesh.raycast = acceleratedRaycast;
    bvh = bvh || new MeshBVH(mesh.geometry, { verbose: false });
    mesh.geometry.boundsTree = bvh;
  }
  static copyBVH(meshDest, meshSrc) {
    const existingBVH = meshSrc.geometry.boundsTree;
    if (existingBVH) {
      meshDest.raycast = acceleratedRaycast;
      this.assignBVH(meshDest, existingBVH);
    }
  }
}
